import {
    createField,
    updateField,
} from '../../actions';
import {
    EVENT_STEP_VALIDATE,
} from '../../helpers/consts';

export class SelectField {
    constructor(options) {
        this.validateMessages = {
            isEmpty: __('Select an option'),
        };
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.id = options.id;
        this.label = options.label;
        this.translations = options.translations;
        this.required = options.required !== undefined ? options.required : true;
        this.stepId = options.stepId;
        const fieldState = this.state.formFields.find(field => field.id === this.id);
        this.value = (fieldState && fieldState.value) ? fieldState.value : '';
        this.isValid = false;
        this.options = options.options || [];

        this.FieldCssClass = options.FieldCssClass || '';
        this.FormCssClass = options.FormCssClass || '';

        this.$el = this.createFieldElement();

        if (this.value !== '' || !this.required) {
            this.validate();
        }
    }

    createFieldElement() { // eslint-disable-line class-methods-use-this
        let debounceTimeout;
        const $field = document.createElement('div');
        const $fieldLabel = document.createElement('label');
        this.$customSelect = document.createElement('div');
        this.$fieldSelect = document.createElement('select');
        this.$fieldMessage = document.createElement('span');

        this.$fieldSelect.innerHTML = `<option selected value>${__('Choose')}</option>`;
        this.$fieldSelect.innerHTML += this.options.map(el => `<option value="${el.value}">${el.name}</option>`).join(', ');

        this.$fieldSelect.id = this.id;
        this.$fieldSelect.required = false;
        this.$fieldSelect.value = this.value ? this.value : '';
        $fieldLabel.setAttribute('for', this.id);
        $fieldLabel.innerHTML = this.label;

        $field.classList.add('field', 'form-group')
        if (this.FormCssClass) {
            $field.classList.add(this.FormCssClass)
        }

        $fieldLabel.classList.add('field-label');
        this.$customSelect.classList.add('formControls');
        this.$fieldSelect.classList.add('custom-select', 'form-control');
        if (this.FieldCssClass) {
            this.$fieldSelect.classList.add(this.FieldCssClass);
        }
        this.$fieldMessage.classList.add('invalid-feedback');
        this.$fieldMessage.setAttribute('role', 'alert');
        this.$customSelect.append(this.$fieldSelect);

        $field.appendChild($fieldLabel);
        $field.appendChild(this.$customSelect);
        $field.appendChild(this.$fieldMessage);

        this.store.dispatch(createField(this.id, this.label, this.stepId));
        this.$fieldSelect.addEventListener('blur', this.validate.bind(this));
        this.$fieldSelect.addEventListener('input', () => {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(this.validate.bind(this), 100);
        });

        return $field;
    }

    getSelectElement() {
        return this.$fieldSelect;
    }

    validate() {
        this.$fieldSelect.classList.remove('is-invalid');
        this.$fieldSelect.classList.remove('is-valid');

        this.store.dispatch(updateField(this.id, this.$fieldSelect.value, this.isValid, this.label));
        this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default SelectField;
